import base from './base'
const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'
import { getDeviceType } from './http'

export default {

  // 获取郎中列表
  getList(params) {
    return base.get('/ai/doctor/index', params)
  },

  // 获取郎中详情
  getDetail(params) {
    return base.post('/ai/doctor/detail', params)
  },

  // 流式会话接口
  async streamChat(params) {
    const response = await fetch(`${baseURL}/chat/Chat/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'XX-Api-Version': '1.0', // 固定值
        'Accept-Language': 'zh-cn', // 默认值
        'XX-Device-Type': getDeviceType(),
        'XX-Token': localStorage.getItem('authToken') || ''
      },
      body: JSON.stringify(params)
    })

    return response
  }
}
